import React from 'react';
import { Field, useField } from 'react-final-form';
import { RadiobuttonWrapper } from 'components/forms';

import styles from './Radiogroup.module.scss';
import classNames from 'classnames';

export interface IValues {
  label: string;
  value: any;
}

export interface IRadiogroupProps {
  title: string;
  name: string;
  radios: IValues[];
  disabled?: boolean;
  className?: string;
}

const Radiogroup: React.FC<IRadiogroupProps> = (props) => {
  const { title, name, radios, disabled, className } = props;
  const {
    input: { onChange },
  } = useField(name);
  // TODO: Refactor input logic
  if (title === 'DELETE' && disabled) {
    onChange('');
  }
  const rootClassName = classNames(styles.root, className, { [styles.disabled]: disabled });

  return (
    <div className={rootClassName}>
      <p className={styles.title}>{title}:</p>
      {radios.map((radio) => (
        <Field
          label={radio.label}
          name={name}
          value={radio.value}
          type='radio'
          component={RadiobuttonWrapper}
          className={styles.radiobutton}
          key={radio.value}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default Radiogroup;
